export default "__VITE_ASSET__DBBibmPN__"